import React, { useState } from 'react'
import moment from 'moment'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import SendIcon from '@mui/icons-material/Send'

const Comments = ({ comments, onSubmit }) => {
  const [newComment, setNewComment] = useState('')
  const handleSubmit = () => onSubmit(newComment).then(() => setNewComment(''))
  return (
    <Stack gap={1}>
      <Stack direction={{ xs: 'column', lg: 'row' }} gap={1}>
        <TextField
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Add a new comment"
          fullWidth
          autoComplete="off"
        />
        <IconButton
          onClick={handleSubmit}
          sx={{ borderRadius: 1 }}
          color="success"
        >
          <SendIcon />
        </IconButton>
      </Stack>
      {comments
        .sort((a, b) => moment(b.createdAt) - moment(a.createdAt))
        .map((comment) => (
          <Box
            borderBottom="dotted 1px #ADA8B6"
            display="flex"
            padding={1}
            key={comment._id}
            gap={1}
          >
            <Avatar
              src={comment?.author?.photograph}
              sx={{ borderRadius: 1 }}
            />
            <Stack>
              <Typography variant="title2" fontSize="1rem">
                {comment?.author?.firstName} {comment?.author?.lastName}
              </Typography>
              <Typography variant="caption">
                {moment(comment.createdAt).format('Do MMM YYYY - HH:mm')}
              </Typography>
              <Typography>{comment?.comment ?? comment?.note ?? ''}</Typography>
            </Stack>
          </Box>
        ))}
    </Stack>
  )
}

export default Comments
